export function tileRevKey(z, x, y) {
  return `${z}/${x}/${y}`
}

export function withTileRev(url, z, x, y, revs) {
  if (!url || !revs) return url
  const r = revs[tileRevKey(z, x, y)]
  if (r == null) return url
  const sep = url.includes("?") ? "&" : "?"
  return `${url}${sep}r=${r}`
}

export function applyTileRevs(revs, tiles) {
  if (!revs) return revs
  for (const tile of tiles || []) {
    if (tile == null || tile.r == null) continue
    const z = Number(tile.z)
    const x = Number(tile.x)
    const y = Number(tile.y)
    if (![z, x, y].every(Number.isFinite)) continue
    revs[tileRevKey(z, x, y)] = tile.r
  }
  return revs
}

export function tileSrcNeedsUpdate(el, url) {
  if (!el || !url) return false
  const current = el.src || el.getAttribute?.("src") || ""
  if (!current) return true
  if (typeof URL !== "function") return current !== url
  try {
    const href = typeof window !== "undefined" && window.location ? window.location.href : "http://local.test/"
    return current !== new URL(url, href).href && current !== url
  } catch (_error) {
    return current !== url
  }
}
